import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    ButtonItem,
    ErrorItem,
    SelectTurnosItem,
    DatePickerItem,
    SelectEmpleadosItem
} from "../../../../Components/Items";
import moment from "moment";

class EditarAsignacionTurno extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
    };
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible)
            this.consultarTodo();
    }
    cerrarEditarAsignacionTurno(codigo) {
        this.props.cerrarEditarAsignacionTurno(codigo);
    }
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "asignacionesTurnos/datosAsignacionTurno",
                { empresaId: this.props.empresaId, asignacionTurnoId: this.props.asignacionTurnoId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.formRef.current.setFieldsValue({
                        ...res.data.data,
                        inicio: res.data.data.inicio ? moment(res.data.data.inicio) : null,
                        fin: res.data.data.fin ? moment(res.data.data.fin) : null,
                    });
                } else {
                    message.error("Error no se encontro informacion de la asignacion de turno");
                }
            });
        this.setState({ loading: false });
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "asignacionesTurnos/editarAsignacionTurno",
                { ...values, empresaId: this.props.empresaId, asignacionTurnoId: this.props.asignacionTurnoId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha editado una asignacion de turno");
                    this.formRef.current.resetFields();
                    this.cerrarEditarAsignacionTurno(res.data.codigo);
                } else if (res.data.success === 1) {
                    message.error("No se puede editar la asignacion de turno");
                } else {
                    message.error("Hubo un error y la asignacion de turno no se edito");
                }
            });
    }
    render() {
        return (
            <>
                <ModalItem
                    title="Editar Asignacion de Turno"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarEditarAsignacionTurno.bind(this)}
                    paddingTop
                >
                    <Form
                        ref={this.formRef}
                        name="editarAsignacionTurno"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Editar
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <FormItem
                            label="Inicio"
                            name="inicio"
                            required
                            margin
                        >
                            <DatePickerItem
                                placeholder="Fecha de Inicio"
                                allowClear={false}
                            />
                        </FormItem>
                        <FormItem
                            label="Fin"
                            name="fin"
                            required
                            margin
                        >
                            <DatePickerItem
                                placeholder="Fecha de Fin"
                                allowClear={false}
                            />
                        </FormItem>
                        <FormItem
                            label="Turno"
                            name="turnoId"
                            fieldKey="turnoId"
                            required
                            margin
                        >
                            <SelectTurnosItem
                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                headersToken={this.props.headersToken}
                                sinBorde
                                autoFocus
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Turno"
                            />
                        </FormItem>
                        <FormItem
                            label="Empleado"
                            name="empleadoId"
                            fieldKey="empleadoId"
                            required
                            margin
                        >
                            <SelectEmpleadosItem
                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                headersToken={this.props.headersToken}
                                sinBorde
                                autoFocus
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Empleados"
                            />
                        </FormItem>
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(EditarAsignacionTurno);
